__turbopack_context__.v({
  "container": "LocaleSelector-module-scss-module__vlB_ja__container",
});
